import React, { useState } from 'react';
import FilterButton from './FilterButton';
import TourBundleGrid from './TourBundleGrid';
import TourParagraph from './TourParagraph';
import type { Bundle, Tour } from '../types';

interface BundleToursProps {
    bundleTitle: string;
    tours: Tour[];
    bundles: Bundle[];
    clickBundleFunction: (bundleTours: string[]) => void;
}

function BundleTours({ bundleTitle, tours, bundles, clickBundleFunction }: BundleToursProps) {
    const options = ["All", "Hotel Visitors", "Caye Visitors", "Cruise Passengers"];
    const [filter, setFilter] = useState<string>(options[0]);

    return (
        <div>
            <TourParagraph text={[]} title={bundleTitle} />
            <FilterButton options={options} onChangeFunction={setFilter} defaultValue={options[0]} />
            <TourBundleGrid tours={tours}
                            clickBundleFunction={clickBundleFunction}
                            bundles={bundles}
                            filter={filter === "All" ? null : filter} />
        </div>
    );
}

export default BundleTours;
